import { HostType } from 'configs/theme'
import { FC, c } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import Container from 'components/landing/Container'
import Heading from 'components/landing/Heading'
import Button from 'components/base/Button'

const contentByHost: Partial<
  Record<
    HostType,
    {
      tagline: string
      description: string
      features: {
        tagline: string
        description: string
        image?: string
        imageAlt?: string
        imageClassName?: string
        link?: string
      }[]
      buttonTitle: string
    }
  >
> = {
  sellmonitor: {
    tagline: 'Умные инструменты помогут продавать больше',
    description: '',
    features: [
      {
        tagline: 'Личный кабинет',
        description:
          'Покажем подробный анализ вашего бизнеса со всеми метриками и графиками, чтобы вы могли принимать решения на основании чётких данных',
        image: '/next/img/landing/business_small.png',
        imageAlt: 'Аналитика продаж и показателей бизнеса на маркетплейсах',
      },
      {
        tagline: 'Расчёт поставок',
        description:
          'Вычислим, сколько и на какие склады нужно поставить товаров на основе истории продаж и географии заказов',
      },
      {
        tagline: 'SEO-оптимизация',
        description:
          'Умный алгоритм подберёт ключевые слова, которых не хватает вашему товару, на основе анализа конкурентов',
        link: '/seo-optimization/',
      },
      {
        tagline: 'Генерация описания товаров',
        description:
          'Сгенерируем описания для ваших товаров с помощью искусственного интеллекта и добавим в них нужные ключевые слова',
        image: '/next/img/landing/description_generation.png',
        imageAlt: 'Генерация описания карточки товара с помощью нейросети',
      },
      {
        tagline: 'Управление рекламой',
        description:
          'Поможем контролировать расходы на рекламу с помощью автоматического управления ставками и выбора часов продвижения на основе статистики',
        image: '/next/img/landing/bidder.png',
        imageAlt: 'Автоматическое управление рекламными ставками на Wildberries',
        link: '/bidder/',
      },
      {
        tagline: 'Автоответы на отзывы',
        description:
          'Поддерживайте репутацию бренда с помощью автоматического ответа на отзывы: настройте шаблоны ответов, и мы ответим на положительные отзывы за вас',
      },
      {
        tagline: 'Генерация изображений',
        description:
          'Сгенерируем изображения для ваших товаров с помощью ИИ — сменим фон, заменим или добавим человека, внесём любые изменения',
      },
      {
        tagline: 'Управление ценами',
        description:
          'Управляем ценой товаров на основании остатков, расписания и цен конкурентов; поможем сохранить цену, если включится акция',
        image: '/next/img/landing/repricer.png',
        imageAlt: 'Репрайсер для автоматического управления ценами на маркетплейсах',
        link: '/repricer/',
      },
      {
        tagline: 'ИИ-аудит карточки товара',
        description:
          'Проверим контент карточки: изображения, описания, характеристики. Найдем ошибки и предложим улучшения',
      },
    ],
    buttonTitle: 'Узнать больше',
  },
  uzum: {
    tagline: 'Aqlli vositalar ko‘proq sotishga yordam beradi',
    description: '',
    features: [
      {
        tagline: 'Shaxsiy kabinet',
        description:
          'Biznesingizning batafsil tahlilini barcha metrikalar va grafiklar bilan ko‘rsatamiz, shunda siz aniq ma’lumotlarga asoslangan qarorlar qabul qilishingiz mumkin',
        image: '/next/img/landing/business_small.png',
      },
      {
        tagline: 'Yetkazib berish hisob-kitobi',
        description:
          'Sotuvlar tarixi va buyurtmalar geografiyasiga asoslanib, qaysi omborlarga qancha mahsulot yetkazib berish kerakligini hisoblaymiz',
      },
      {
        tagline: 'SEO-optimallashtirish',
        description:
          'Aqlli algoritm raqobatchilar tahliliga asoslanib, mahsulotingizga yetishmayotgan kalit so‘zlarni tanlaydi',
      },
      {
        tagline: 'Mahsulot tavsiflarini yaratish',
        description:
          'Sun’iy intellekt yordamida mahsulotlaringiz uchun tavsiflar yaratamiz va ularga kerakli kalit so‘zlarni qo‘shamiz',
        image: '/next/img/landing/description_generation.png',
      },
      {
        tagline: 'Reklamani boshqarish',
        description:
          'Avtomatik stavkalarni boshqarish va reklama eng yaxshi soatlarda ishga tushirish orqali reklama xarajatlarini tejashga yordam beramiz',
        image: '/next/img/landing/bidder.png',
      },
      {
        tagline: 'Sharhlarga avtomatik javoblar',
        description:
          'Sharhlarga avtomatik javob berish orqali brend obro‘sini saqlang: javob shablonlarini sozlang va biz ijobiy sharhlarga siz uchun javob beramiz',
      },
    ],
    buttonTitle: 'Batafsil ma’lumot',
  },
  sellscreen: {
    tagline: 'How to increase sales and lower costs?',
    description: 'We provide all the required tools so you can focus on growing your business',
    features: [
      {
        tagline: 'Niche analysis',
        description:
          'Discover potential best-selling products in untapped niches with less competition',
        image: '/next/img/landing/sellscreen/categories_small.png',
      },
      {
        tagline: 'Review tracking',
        description:
          "Manage you store's reputation by monitoring reviews and avoiding unanswered complaints",
      },
      {
        tagline: 'SEO optimization',
        description:
          "Pick popular keywords for your products' description and track their position in the search results",
      },
      {
        tagline: 'Seasonal demand analysis',
        description: 'Easily validate your product’s success with at-a-glance analytics',
        image: '/next/img/landing/sellscreen/charts.png',
      },
      {
        tagline: 'Competitor analysis',
        description:
          "Track sales data by store, brand and product; copy your competitors' successful strategies and avoid their mistakes",
        image: '/next/img/landing/sellscreen/products_small.png',
      },
      {
        tagline: 'Excel exports',
        description: 'Download in-depth analytics data for use in third-party systems',
      },
    ],
    buttonTitle: 'Learn more',
  },
}

const Features: FC<{ content?: NonNullable<(typeof contentByHost)['sellmonitor']> }> = ({
  content: suppliedContent,
}) => {
  const ctx = useUserContext()
  const content = suppliedContent ?? contentByHost[ctx.theme.hostType]!
  const priceManagement = content.features[ctx.theme.hostType === 'sellscreen' ? 6 : 7]

  return (
    <Container data-header-theme="dark" className="bg-gray-900">
      <Heading dark tagline={content.tagline} description={content.description} />
      <ul
        role="list"
        className={c`grid grid-cols-1 grid-rows-6 gap-3 mx-auto mt-12 max-w-2xl text-sm sm:mt-16 sm:grid-cols-2 sm:grid-rows-3 lg:max-w-none lg:grid-cols-3 ${ctx.theme.hostType === 'sellscreen'} lg:grid-rows-[auto_1fr_1fr_auto] | lg:grid-rows-2`}
      >
        <li className="overflow-hidden relative p-8 bg-gradient-to-br from-white to-blue-100 rounded-2xl border border-gray-800 lg:col-span-2">
          <h3 className="text-lg font-medium lg:w-2/5">{content.features[0].tagline}</h3>
          <p className="mt-2 lg:w-2/5 text-base">{content.features[0].description}</p>
          <img
            src={content.features[0].image}
            alt={content.features[0].imageAlt ?? ''}
            className={c`hidden absolute top-0 bottom-0 -right-[12rem] lg:block xl:-right-1 ${content.features[0].imageClassName}`}
          />
        </li>
        <li className="p-8 bg-gradient-to-br from-blue-200 to-cyan-400 rounded-2xl border border-gray-800">
          <h3 className="text-lg font-medium">{content.features[1].tagline}</h3>
          <p className="mt-2 text-base">{content.features[1].description}</p>
        </li>
        {ctx.theme.hostType !== 'sellscreen' && (
          <li className="p-8 text-black bg-gradient-to-tl from-cyan-400 to-violet-300 rounded-2xl border border-gray-800">
            <h3 className="text-lg font-medium">{content.features[6].tagline}</h3>
            <p className="mt-2 text-base">{content.features[6].description}</p>
          </li>
        )}
        <li className="overflow-hidden relative p-8 bg-gradient-to-br from-violet-300 to-purple-400 rounded-2xl border border-gray-800 lg:row-span-2">
          <h3 className="text-lg font-medium">{content.features[3].tagline}</h3>
          <p className="mt-2 text-base">{content.features[3].description}</p>
          <img
            src={content.features[3].image}
            alt={content.features[3].imageAlt ?? ''}
            className={c`hidden lg:block ${ctx.theme.hostType === 'sellscreen'} mt-8 -mx-8 -mb-8 w-[calc(100%+4rem)] max-w-none | absolute bottom-0 left-0 w-full ${content.features[3].imageClassName}`}
          />
        </li>
        <li className="lg:row-span-2">
          <a
            href={content.features[4].link}
            className={c`overflow-hidden relative flex h-full flex-col justify-end p-8 bg-gradient-to-br from-gray-500 to-gray-100 rounded-2xl border border-gray-800 ${Boolean(content.features[4].link)} hover:saturate-[1.2] transition-all duration-300`}
          >
            <h3 className="relative z-10 text-lg font-medium">{content.features[4].tagline}</h3>
            <p className="relative z-10 mt-2 text-base">{content.features[4].description}</p>
            {content.features[4].link && (
              <span className="relative z-10 mt-4 text-sm font-medium text-primary-700">
                {`${content.buttonTitle} →`}
              </span>
            )}
            <img
              src={content.features[4].image}
              alt={content.features[4].imageAlt ?? ''}
              className={c`pointer-events-none hidden absolute top-0 left-0 w-full lg:block ${content.features[4].imageClassName}`}
            />
          </a>
        </li>
        <li className="p-8 text-white bg-gradient-to-br from-gray-800 to-gray-600 rounded-2xl border border-gray-800">
          <h3 className="text-lg font-medium">{content.features[5].tagline}</h3>
          <p className="mt-2 text-base">{content.features[5].description}</p>
        </li>
        <li
          className={
            ctx.theme.hostType === 'sellscreen'
              ? c`h-full`
              : c`h-full ${content.features[2].link} sm:col-span-2 lg:col-span-2`
          }
        >
          {content.features[2].link ? (
            <a
              className="p-8 h-full block bg-gradient-to-tr from-lime-300 to-yellow-300 hover:saturate-[1.2] transition-all duration-300 rounded-2xl border border-gray-800"
              href={content.features[2].link}
              target="_blank"
              rel="noreferrer"
            >
              <h3 className="text-lg font-medium">{content.features[2].tagline}</h3>
              <p className="mt-2 text-base">{content.features[2].description}</p>
              <Button
                theme="white"
                className="mt-4 !border-transparent !bg-white/70 hover:!bg-gray-50"
              >
                {content.buttonTitle}
              </Button>
            </a>
          ) : (
            <div className="p-8 h-full block bg-gradient-to-tr from-lime-300 to-yellow-300 rounded-2xl border border-gray-800">
              <h3 className="text-lg font-medium">{content.features[2].tagline}</h3>
              <p className="mt-2 text-base">{content.features[2].description}</p>
            </div>
          )}
        </li>
        {content.features[8] && (
          <li className="p-8 text-black bg-gradient-to-br from-blue-400 to-green-400 rounded-2xl border border-gray-800">
            <h3 className="text-lg font-medium">{content.features[8].tagline}</h3>
            <p className="mt-2 text-base">{content.features[8].description}</p>
          </li>
        )}
        {priceManagement && (
          <li className="sm:col-span-2 lg:col-span-3">
            <a
              href={priceManagement.link}
              target="_blank"
              rel="noreferrer"
              className={c`block overflow-hidden relative p-8 bg-gradient-to-br from-lime-300 to-blue-100 rounded-2xl border border-gray-800 hover:saturate-[1.2] transition-all duration-300 ${ctx.theme.hostType === 'sellscreen'} h-full`}
            >
              <h3 className="text-lg font-medium lg:w-1/2">{priceManagement.tagline}</h3>
              <p className="mt-2 lg:w-1/2 text-base">{priceManagement.description}</p>
              <img
                src={priceManagement.image}
                alt={priceManagement.imageAlt ?? ''}
                className={c`hidden absolute top-0 bottom-0 -right-[20rem] lg:block xl:-right-[6rem] h-full w-auto ${priceManagement.imageClassName}`}
              />
              {priceManagement.link && (
                <Button
                  theme="white"
                  className="mt-4 !border-transparent !bg-white/70 hover:!bg-gray-50"
                >
                  {content.buttonTitle}
                </Button>
              )}
            </a>
          </li>
        )}
      </ul>
    </Container>
  )
}

export default Features
